import { useState } from "react";
import RadioButton from "./RadioButton";

## Basic Usage

export function BasicRadioButton() {
  const [selected, setSelected] = useState("option1");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      <RadioButton
        name="basic"
        id="basic-1"
        value="option1"
        label="Option 1"
        checked={selected === "option1"}
        onClick={() => setSelected("option1")}
      />
      <RadioButton
        name="basic"
        id="basic-2"
        value="option2"
        label="Option 2"
        checked={selected === "option2"}
        onClick={() => setSelected("option2")}
      />
      <RadioButton
        name="basic"
        id="basic-3"
        value="option3"
        label="Option 3"
        checked={selected === "option3"}
        onClick={() => setSelected("option3")}
      />
    </div>
  );
}

<BasicRadioButton />

---

## Disabled State

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <RadioButton name="disabled" id="dis-1" value="1" label="Enabled" />
  <RadioButton name="disabled" id="dis-2" value="2" label="Disabled" disabled title="This option is unavailable" />
  <RadioButton name="disabled" id="dis-3" value="3" label="Disabled checked" disabled checked title="Cannot be changed" />
</div>

Hover over disabled buttons to see the tooltip.

---

## Payment Method Example

export function PaymentMethod() {
  const [method, setMethod] = useState("card");
  const options = [
    { value: "card", label: "Credit Card" },
    { value: "paypal", label: "PayPal" },
    { value: "bank", label: "Bank Transfer" },
  ];
  return (
    <div>
      <p style={{ marginBottom: "0.5rem", fontWeight: 500 }}>Select payment method:</p>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {options.map((opt) => (
          <RadioButton
            key={opt.value}
            name="payment"
            id={`payment-${opt.value}`}
            value={opt.value}
            label={opt.label}
            checked={method === opt.value}
            onClick={() => setMethod(opt.value)}
          />
        ))}
      </div>
      <p style={{ marginTop: "0.75rem", color: "#666" }}>Selected: **{method}**</p>
    </div>
  );
}

<PaymentMethod />

---

## Inline Layout

export function InlineRadioButtons() {
  const [rating, setRating] = useState("good");
  return (
    <div>
      <p style={{ marginBottom: "0.5rem" }}>How would you rate this?</p>
      <div style={{ display: "flex", gap: "1rem" }}>
        <RadioButton
          name="rating"
          id="rating-bad"
          value="bad"
          label="Bad"
          checked={rating === "bad"}
          onClick={() => setRating("bad")}
        />
        <RadioButton
          name="rating"
          id="rating-ok"
          value="ok"
          label="OK"
          checked={rating === "ok"}
          onClick={() => setRating("ok")}
        />
        <RadioButton
          name="rating"
          id="rating-good"
          value="good"
          label="Good"
          checked={rating === "good"}
          onClick={() => setRating("good")}
        />
        <RadioButton
          name="rating"
          id="rating-great"
          value="great"
          label="Great"
          checked={rating === "great"}
          onClick={() => setRating("great")}
        />
      </div>
    </div>
  );
}

<InlineRadioButtons />


